import React from "react";
import * as cls from "./synopsis.module.scss";
import { useSelector } from "react-redux";
import { TableLoader, TableModel } from "../../components/tableLoader";
function Synopsis() {
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);

  const loader = {
    title: "Выполнение электронных конспектов",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/portfolio/synopsis",
      data: {
        access_token,
        study_contract_id: contractId,
        return_row_value: 0,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);

    table.columns = table.columns.filter((el) => !reg.includes(el.field));
    table.columns.forEach((element) => {
      if (element.field === "e_notes") {
        element.type = "html";
      }
      if (element.field === "end_time") {
        element.type = "date";
      }
      // if (element.field === "study_session_state_id") {
      //   element.hide = true;
      // }
      // if (element.field === "mod_discip_id") {
      //   element.hide = true;
      // }
    });

    return table;
  }
  const reg = ["study_session_state_id", "mod_discip_id"];
  return <TableLoader {...loader} />;
}
export default Synopsis;
